import { ModalBody, ModalHeader } from '@core/components'
import { IconGeoObjSeismdataVerts } from '@core/icons'
import { usingMovingModal } from '@library/model'
import { forwardRef } from 'react'

import { useStepControllerMethods } from './components'
import css from './SpeedLaws.css'
import { SpeedLawsBody } from './SpeedLawsBody'

type SpeedLawsProps = {
  closeModal: VoidFunction
  onClose?: VoidFunction
}

const SpeedLaws = forwardRef<HTMLDivElement, SpeedLawsProps>(function SpeedLaws(
  { closeModal, onClose },
  ref,
) {
  const { goToStep, getStep } = useStepControllerMethods()

  const handleCloseModal = () => {
    closeModal()
    onClose?.()
    goToStep(getStep(0).id)
  }

  return (
    <>
      <ModalHeader
        ref={ref}
        title="Скоростные законы"
        icon={IconGeoObjSeismdataVerts}
        onCloseClick={handleCloseModal}
      />
      <ModalBody className={css.container}>
        <SpeedLawsBody />
      </ModalBody>
    </>
  )
})

export const SpeedLawsModal = usingMovingModal(SpeedLaws)
